import React, { useState ,useEffect} from "react";
import Sidebar from "../Components/Siderbar";
import Footer from "../Components/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import '../Customize_Css/AddVendor.css';

const mapEmployee = (record) => ({
  employeeId: record.employeeId || "",
  employeeName: record.employeeName || "",
  phoneNumber: record.phoneNumber || "",
  emailId: record.emailId || "",
  designation: record.designation || "",
  department: record.department || "",
  city: record.city || "",
  gender: record.gender || "",
  address: record.address || "",
  hireDate: record.hireDate ? new Date(record.hireDate).toISOString().split("T")[0] : "",
});

const UpdateEmployee = () => {
    const { id: employeeId } = useParams(); 
  const navigate = useNavigate();
  const location = useLocation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const [formData, setFormData] = useState({
    employeeId: "",
    employeeName: "",
    phoneNumber: "",
    emailId: "",
    designation: "",
    department: "",
    gender: "",
    city: "",
    address: "",
    hireDate: "",
  });

    useEffect(() => {
      const listed = location.state?.employee;
      if (listed && String(listed._id) === String(employeeId)) {
        setFormData(mapEmployee(listed));
      }

      const fetchData = async () => {
        try {
          const response = await fetch(
            `${BASE_URL}/login/api/login/employees/${employeeId}`,
            {
              headers: {
                  Authorization: `Bearer ${AuthorizationToken}`,
                },
              }
          );
          if (response.ok) {
            const data = await response.json();
            const record = data.employee || data.data || data;
            setFormData(mapEmployee(record));
          } else if (!listed) {
            toast.error("Failed to fetch data. Please try again later.");
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          if (!listed) {
            toast.error("An error occurred while fetching data.");
          }
        }
      };
  
      fetchData();
    }, [employeeId]);
  
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };
  const handleSubmit = async () => {
    try {
      const response = await fetch(`${BASE_URL}/login/api/login/employees/${employeeId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Employee updated successfully");
        navigate('/view-employee');
      } else {
        toast.error(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error adding employee:", error);
      toast.error("Failed to add employee. Please try again.");
    }
  };

  const handleCancel = () => {
    navigate('/view-employee');
  };

  return (
    <>
      <Sidebar />
      <div className="vendor-form-page">
        <div className="vendor-form-shell">
          <header className="vendor-form-hero">
            <div>
              <p className="vendor-form-kicker">People</p>
              <h1>Update Employee</h1>
              <p>Review the saved details, then change the fields you need.</p>
            </div>
            <button type="button" className="vendor-form-back-btn" onClick={() => navigate('/view-employee')}>Back to Employees</button>
          </header>
          <div className="vendor-form-card">
            <div className="vendor-form-card-head">
              <div>
                <h2>Employee Information</h2>
                <p>Contact, designation, department, and address.</p>
              </div>
            </div>
            <div className="vendor-form-card-body">
              <div className="row">
                <div className="col">
                  <label htmlFor="employeeId">Employee ID</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    id="employeeId"
                    value={formData.employeeId}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label htmlFor="employeeName">Employee Name</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    id="employeeName"
                    value={formData.employeeName}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label htmlFor="phoneNumber">Phone Number</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    id="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col">
                  <label htmlFor="emailId">Email ID</label>
                  <input
                    type="email"
                    className="form-control bg-light"
                    id="emailId"
                    value={formData.emailId}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label htmlFor="designation">Designation</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    id="designation"
                    value={formData.designation}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label htmlFor="department">Department</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    id="department"
                    value={formData.department}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col">
                  <label htmlFor="gender">Gender</label>
                  <select
                    className="form-control bg-light"
                    id="gender"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option>Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className="col">
                  <label htmlFor="city">City</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    id="city"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label htmlFor="hireDate">Hire Date</label>
                  <input
                    type="date"
                    className="form-control bg-light"
                    id="hireDate"
                    value={formData.hireDate}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col">
                  <label htmlFor="address">Address</label>
                  <textarea
                    className="form-control bg-light"
                    id="address"
                    rows="2"
                    value={formData.address}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div className="vendor-form-actions">
            <button type="button" className="vendor-form-cancel" onClick={handleCancel}>Cancel</button>
            <button type="button" className="vendor-form-submit" onClick={handleSubmit}>Update Employee</button>
          </div>
        </div>
        <div className="vendor-form-footer">
          <Footer />
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }} 
        />
    </>
  );
};

export default UpdateEmployee;